import PropTypes from "prop-types";
import getAvatarUrl from "../../../../utils/get-avatar-url";

export const ReportByCoachOrganizationBillingComponent = ({
  reportByCoach,
  webAppTheme,
}) => {
  return (
    <>
      {reportByCoach.map((coach) => {
        const { coachName, coachEmail, athletes, amountPerCoach, coachAvatar } =
          coach;
        const image = getAvatarUrl(
          { avatar: coachAvatar },
          null,
          webAppTheme,
          webAppTheme !== "dark" ? true : false
        );
        if (athletes.length === 0) return null;
        return (
          <section
            role="table-wrapper"
            data-borders-inside
            key={coachEmail}
            className="organization-billing-report"
          >
            <div id="coach-identifier">
              <img
                src={image}
                loading="lazy"
                className="profile-picture w-12 h-12 rounded-full"
              />
              <div>
                <h4>{coachName}</h4>
                <p className="p4 opacity-50 pt-[.125rem]">{coachEmail}</p>
              </div>
            </div>
            <table role="report-table">
              <thead className="labels">
                <tr>
                  <th className="name">Athlete</th>
                  <th className="email">Email</th>
                  <th className="amount">Total days</th>
                </tr>
              </thead>
              <tbody>
                {athletes.map((athlete) => {
                  const {
                    athleteName,
                    athleteEmail,
                    amount: athleteAmount,
                    athleteId,
                  } = athlete;
                  return (
                    <tr className="report" key={String(athleteId)}>
                      <td className="name">{athleteName}</td>
                      <td className="email">{athleteEmail}</td>
                      <td className="amount">
                        {Number(athleteAmount).toFixed(0)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="total">
              <div className="totalValue">
                <span>Subtotal: </span>
                <span className="clipped font-semibold">{`$${amountPerCoach}`}</span>
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
};

ReportByCoachOrganizationBillingComponent.propTypes = {
  reportByCoach: PropTypes.array,
  webAppTheme: PropTypes.string,
};
